import MicroModal from 'micromodal';

const modalOpenClass = 'modal-is-open';
const rootEl         = document.documentElement;

const init = () => {
	MicroModal.init({
		onShow: modal => rootEl.classList.add(modalOpenClass),
		onClose: modal => rootEl.classList.remove(modalOpenClass),
	});
}

export default init;